import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideGatekeeper } from '@the-guild-llc/gatekeeper-dev';

import { routes } from './app.routes';
import { environment } from "../environments/environment";

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideGatekeeper(environment.guildConfig)
  ]
};
